module.exports = __webpack_public_path__ + "static/media/bq-bo.c82fc5a3.svg";